import type { KnowledgeArticle } from "../types"

export const wanneerGeenAi: KnowledgeArticle = {
  id: "insight:wanneer-geen-ai",
  pageType: "knowledge-article",
  slug: { nl: "wanneer-geen-ai" },
  title: {
    nl: "Wanneer een Bedrijf Juist Géén AI Moet Gebruiken",
    en: "Wanneer een Bedrijf Juist Géén AI Moet Gebruiken",
  },
  description: {
    nl: "AI is niet altijd het antwoord. Vijf situaties waarin een bedrijf beter even kan wachten, iets eenvoudigers kan bouwen of AI juist moet laten.",
    en: "AI is not always the answer. Five situations where a company is better off waiting, building something simpler, or skipping AI entirely.",
  },
  h1: {
    nl: "Wanneer moet een bedrijf juist géén AI gebruiken?",
    en: "Wanneer moet een bedrijf juist géén AI gebruiken?",
  },
  published: "2026-08-26",
  modified: "2026-08-26",
  author: "Camiel Schmeitz",
  sections: [
    {
      type: "paragraph",
      text: "We zijn een AI-ontwikkelbedrijf dat soms adviseert om geen AI te bouwen. Dat klinkt tegenintuïtief, maar we verliezen liever een opdracht dan dat we een klant op onnodige kosten jagen. Dit zijn de situaties waarin wij bedrijven doorgaans afraden.",
    },
    {
      type: "heading",
      text: "1. Het proces werkt al goed en snel genoeg",
    },
    {
      type: "paragraph",
      text: "Als een proces weinig tijd kost, zelden fout gaat en niet schaalt als knelpunt, is automatisering ervan verspilling. De investering verdien je nooit terug omdat er geen pijn is om weg te nemen. AI oplossingen zoeken naar problemen is de duurste vorm van innovatietheater.",
    },
    {
      type: "heading",
      text: "2. Er is geen goede data of documentatie",
    },
    {
      type: "paragraph",
      text: "Een RAG-systeem zonder onderhoudbare kennisbank geeft stellige antwoorden uit verouderde documentatie — gevaarlijker dan geen systeem. Een model zonder representatieve data leert ruis. In beide gevallen is stap één geen AI-project maar orde op zaken stellen in de informatievoorziening. Pas daarna is bouwen zinvol.",
    },
    {
      type: "heading",
      text: "3. Fouten zijn onacceptabel en oncontroleerbaar",
    },
    {
      type: "paragraph",
      text: "Taalmodellen zijn probabilistisch: ze kunnen naast het antwoord zitten. Waar een enkele foute uitkomst onherstelbare schade veroorzaakt en menselijke controle onmogelijk of ondeugdelijk is, hoort AI die beslissing niet autonoom te nemen. Assistentie (mens blijft in control) kan dan wél; volledige delegatie niet.",
    },
    {
      type: "heading",
      text: "4. Niemand binnen de organisatie draagt het resultaat",
    },
    {
      type: "paragraph",
      text: "Systemen hebben beheer nodig: iemand die monitort, bijstuurt, kennis actueel houdt en vragen beantwoordt. Zonder interne eigenaar slijt elke oplossing. Beter eerst die rol en verantwoordelijkheid regelen, ook als dat de start vertraagt — anders koop je een systeem met aflopende waarde.",
    },
    {
      type: "heading",
      text: "5. De businesscase bestaat alleen uit enthousiasme",
    },
    {
      type: "paragraph",
      text: "'Concurrenten doen het' is geen businesscase. Als niemand kan benoemen welk probleem wordt opgelost, welke tijd of kosten het oplevert en hoe dat gemeten wordt, is het nog vroeg. Eerst de aanname formuleren, dan klein testen. Soms is het eerlijke antwoord: dit idee is het budget niet waard — en dat advies scheelt het meeste geld van allemaal.",
    },
    {
      type: "callout",
      title: "Onze belofte",
      text: "In een kennismaking krijg je onze eerlijke inschatting — inclusief 'nog even wachten' of 'dit lost niets op'. Die ongezouten eerlijkheid is precies waar klanten ons voor kiezen.",
    },
  ],
  relatedServiceIds: ["ai-workshops", "ai-development"],
  relatedCaseIds: [],
}
